import React from 'react';
import IProdukt from '../../interfaces/IProdukt';
import { navigate } from "gatsby"
import { filterToLabel } from '../../utils/FilterHelper';

type Props = {
    filterType: string;
    product: IProdukt;
    options: Array<IProdukt>;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { product, options, filterType, onChange } = props;
    const filterName = filterType.charAt(0).toUpperCase() + filterType.slice(1);
    const [value, setValue] = React.useState("");

    React.useEffect(() => {
        for (const ofilter of product.filters) {
            if (ofilter.typ === filterType) {
                const newValue = ofilter.wert.split("|")[0];
                setValue(newValue);
                onChange(newValue);
                continue;
            }
        }
    }, []);

    // extract options
    const selectOptions: Array<{url: string; value: string;  name: string;}> = [];
    
    const getMatches = (option) => {
        let matches: number = 0;
        for (const ofilter of option.filters) {
            // don't consider the selected filterType!
            if (ofilter.typ === filterType) {
                continue;
            }

            let found = false;
            for (const mainFilter of product.filters) {
                if (mainFilter.typ === ofilter.typ  && ofilter?.widgetType && ofilter.widgetType === "link") {
                    const mfws = mainFilter.wert.split("|");
                    for (const mfw of mfws ) {
                        const ofws = ofilter.wert.split("|");
                        for (const ofw of ofws) {
                            if (mfw === ofw) {
                                found = true;
                            }
                        }
                    }
                }
            }

            if (found) {
                matches++;
            }
        }
        return matches;
    }
    
    // get max matched filters of an option!
    let maxMatched: number = 0;
    for (const option of options) {
       const matches = getMatches(option);

        if (matches > maxMatched) {
            maxMatched = matches;
        }
    }

    // get the options per filter with considering maxMatches!
    for (const option of options) {
        

        if (option.filters) {
            for (const filter of option.filters) {
                if (filter.typ === filterType) {

                    // split values if multiple are given
                    const values = filter.wert.split("|");
                    for (const value of values) {
                        //check if the value is already in the array
                        let found = false;
                        let index = 0;
                        for (const so of selectOptions) {
                            if (so.name === value) {
                                found = true;
                                break;
                            }
                            index++;
                        }

                        if (!found) {
                            selectOptions.push({url: option.url, value: value, name: value});
                        } else {
                            const matches = getMatches(option);

                            if (matches >= maxMatched) {
                                selectOptions[index].url = option.url;
                            }
                        }
                    }
                    
                }
            }
        }
    }

    const onSelect = (e) => {
        for (const o of selectOptions) {
            if (o.value === e.currentTarget.value) {
                setValue(o.value);
                onChange(o.value);
                navigate("/produkte/" + o.url);
            }
        }
        
    }

    return <div className="field  is-horizontal">
        <div className="field-label is-normal">
            <label className="label">{filterToLabel(filterName)}</label>
        </div>
        <div className="field-body">
            <div className="field">
                <div className="control">
                    <div className="select is-fullwidth">
                        <select name={filterName} onChange={onSelect} value={value}>
                            {selectOptions.map((option, optionKey) => {
                                return <option key={optionKey} value={option.value} >{option.name}</option>
                            })}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}